import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CheckIcon from "src/assets/Check";
import CloseIcon from "src/assets/Close";
import Alert from "src/components/Alert";
import { CSSTransition } from "react-transition-group";
import { loadConfig, saveConfig } from "src/redux/actions/tradelink";
import { addToast } from "src/redux/actions/toasts";

const Config = () => {
  const dispatch = useDispatch();
  const tradelinkConfig = useSelector((state) => state.tradelink.config);
  const [loading, setLoading] = useState(false);
  const [configOpen, setConfigOpen] = useState(true);
  const [userId, setUserId] = useState("");
  const [apiKey, setApiKey] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [inlineError, setInlineError] = useState("");

  useEffect(() => {
    dispatch(loadConfig());
  }, []);

  useEffect(() => {
    if (tradelinkConfig.data) {
      setUserId(tradelinkConfig.data.tradeLinkOneUserid || "");
      setApiKey(tradelinkConfig.data.tradeLinkOneApiKey || "");
    }
  }, [tradelinkConfig.data]);

  function validateForm() {
    const errors = {};
    if (!userId.trim()) {
      errors.userId = "User ID is required";
    }
    if (!apiKey.trim()) {
      errors.apiKey = "API Key is required";
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  }

  async function handleSaveConfig(e) {
    e.preventDefault();
    setInlineError("");
    if (!validateForm()) {
      return;
    }

    setLoading(true);
    try {
      const newConfig = {
        tradeLinkOneUserid: userId.trim(),
        tradeLinkOneApiKey: apiKey.trim(),
        syncEnabled: true,
      };

      await dispatch(saveConfig(newConfig));
      dispatch(
        addToast({
          type: "success",
          message: "Configuration saved successfully!",
        })
      );
      setConfigOpen(false);
    } catch (error) {
      let errorMsg = "Something went wrong, please try again later.";
      if (error?.response?.data?.message) {
        errorMsg = error.response.data.message;
      }
      setInlineError(errorMsg);
    } finally {
      setLoading(false);
    }
  }

  function connectedModal() {
    return (
      <div className="p-4">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body text-center">
                <div className="mb-4">
                  <CheckIcon className="text-success" style={{ fontSize: "4rem" }} />
                </div>
                <h4 className="mb-3">Tradelink Connected Successfully!</h4>
                <p className="text-muted mb-4">
                  Your Tradelink account is now connected and ready to sync orders.
                </p>
                <div className="d-flex justify-content-center">
                  <button
                    className="btn btn-primary me-3"
                    onClick={() => setConfigOpen(true)}
                  >
                    Update Configuration
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function configForm() {
    return (
      <div className="p-4">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <h5 className="mb-0">Tradelink Configuration</h5>
              </div>
              <div className="card-body">
                {inlineError ? (
                  <Alert type="danger" className="mb-3">
                    {inlineError}
                  </Alert>
                ) : null}
                <form onSubmit={handleSaveConfig}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">User ID *</label>
                      <input
                        type="text"
                        className={`form-control ${formErrors.userId ? "is-invalid" : ""}`}
                        value={userId}
                        onChange={(e) => setUserId(e.target.value)}
                        placeholder="Enter your Tradelink User ID"
                      />
                      {formErrors.userId && (
                        <div className="invalid-feedback">{formErrors.userId}</div>
                      )}
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">API Key *</label>
                      <input
                        type="text"
                        className={`form-control ${formErrors.apiKey ? "is-invalid" : ""}`}
                        value={apiKey}
                        onChange={(e) => setApiKey(e.target.value)}
                        placeholder="Enter your Tradelink API Key"
                      />
                      {formErrors.apiKey && (
                        <div className="invalid-feedback">{formErrors.apiKey}</div>
                      )}
                    </div>
                  </div>
                  <div className="d-flex justify-content-end mr-4 pr-1">
                    <button
                      type="button"
                      className="btn btn-secondary me-2 mr-2"
                      onClick={() => setConfigOpen(false)}
                      disabled={loading}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? "Saving..." : "Save Configuration"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (tradelinkConfig.data && tradelinkConfig.data.syncEnabled && !configOpen) {
    return connectedModal();
  }

  return configForm();
};

export default Config; 